import ProductPrice from './ProductPrice'

export default ProductPrice
